import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useParams } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Features from './components/Features';
import Requirements from './components/Requirements';
import Pricing from './components/Pricing';
import DashboardShowcase from './components/DashboardShowcase';
import VideoDemos from './components/VideoDemos';
import HotspotShowcase from './components/HotspotShowcase';
import LeadCaptureForm from './components/LeadCaptureForm';
import Footer from './components/Footer';
import { UIProvider } from './context/UIContext';
import BlogPage from './components/BlogPage'; // Import the BlogPage
import BlogArticle from './components/BlogArticle'; // Import the BlogArticle
import OnboardingPage from './components/OnboardingPage'; // Import the OnboardingPage
import SetupMikrotik from './components/SetupMikrotik'; // Import the SetupMikrotik
import GoogleAnalytics from './components/GoogleAnalytics'; // Import Google Analytics

import './App.css';
import { CssBaseline, Box } from '@mui/material';

function MainContent() {
  const location = useLocation();
  const { slug } = useParams(); // Capture the slug parameter if present

  const isBlogPage = location.pathname === '/blog';
  const isBlogArticle = Boolean(slug); // Check if a slug exists

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const elementId = decodeURIComponent(location.hash.slice(1));
    const scrollToTarget = () => {
      const target = document.getElementById(elementId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    };

    const timeoutId = window.setTimeout(scrollToTarget, 0);
    return () => window.clearTimeout(timeoutId);
  }, [location.hash, location.pathname]);

  return (
    <>
      <Header />
      <Box sx={{ paddingTop: { xs: '70px', md: '80px' } }}>
        {isBlogPage && <BlogPage />}
        {isBlogArticle && <BlogArticle />} {/* Render BlogArticle if a slug exists */}
        {!isBlogPage && !isBlogArticle && (
          <>
            <HeroSection />
            <Features />
            <Requirements />
            <Pricing />
            <DashboardShowcase />
            <VideoDemos />
            <HotspotShowcase />
            <LeadCaptureForm />
            <Footer />
          </>
        )}
      </Box>
    </>
  );
}

function App() {
  return (
    <UIProvider>
      <CssBaseline />
      <Router>
        <GoogleAnalytics />
        <Routes>
          {/* Onboarding route - standalone page without Header/Footer */}
          <Route path="/onboarding" element={<OnboardingPage />} />
          {/* Mikrotik setup route - standalone page without Header/Footer */}
          <Route path="/setup-mikrotik" element={<SetupMikrotik />} />
          {/* Add routes with dynamic parameters for blog articles */}
          <Route path="/blog/:slug" element={<MainContent />} />
          <Route path="/blog" element={<MainContent />} />
          {/* Catch-all route for main content */}
          <Route path="/*" element={<MainContent />} />
        </Routes>
      </Router>
    </UIProvider>
  );
}

export default App;
